import { NgModule } from '@angular/core';

import { CancelledOpportunitySubmissionsPipe } from './cancelled-opportunity-submissions.pipe';

@NgModule({
  exports: [CancelledOpportunitySubmissionsPipe],
  declarations: [CancelledOpportunitySubmissionsPipe],
})
export class CancelledOpportunitySubmissionsPipeModule {}
